import React, { useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { WaveLoading } from 'react-loadingg';

import { PageTitle, SimplePopup } from 'components';
import { PlayerToolbar, PlayerTable, RegAndEditPlayer } from './components';

// >> redux
import {
  getPlayers,
  addPlayer,
  updatePlayer,
  deletePlayer,
} from '../../../redux/actions/players';
// <<

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '120px',
  },
  registerListItemInput: {
    width: '240px',
  },
  registerListItemFilePath: {
    //marginLeft: theme.spacing(2),
    width: '320px',
  },
  registerListItemUpload: {
    marginLeft: theme.spacing(2),
  },
}));

const Player = (props) => {
  const classes = useStyles();

  const {
    players,
    loading
  } = props;

  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userRole, setUserRole] = useState(null);

  const [openDialog, setOpenDialog] = useState(false);
  const [modeRegisterDlg, setModeRegisterDlg] = useState(true);
  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);

  //const [disableRegisterButton, setDisableRegisterButton] = useState(true);
  const [disableRegisterButton, setDisableRegisterButton] = useState(false);
  const [disableEditButton, setDisableEditButton] = useState(true);
  const [disableDeleteButton, setDisableDeleteButton] = useState(true);

  const [selectedPlayers, setSelectedPlayers] = useState([]);

  const [editPlayer, setEditPlayer] = useState(null);

  const handleClickOpenRegisterDialog = () => {

    setEditPlayer(null);
    setModeRegisterDlg(true);

    setOpenDialog(true);
  };

  const handleClickOpenEditDialog = () => {

    if (selectedPlayers.length !== 1){
      return ;
    }

    const id = selectedPlayers[0];
    const selectedPlayer = players.find(player => (player.id === id));

    setEditPlayer(selectedPlayer);
    setModeRegisterDlg(false);

    setOpenDialog(true);
  };

  const handleClickCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleClickSavePlayer = (player) => {

    if (modeRegisterDlg) 
    {
      const newPlayer = {
        name: player.name,
        file: player.file,
        file_size: player.file_size,
        meter_type: player.meter_type,
        version_code: player.version_code,
        modified_user: player.modified_user,
        modified_at: player.modified_at,
        description: player.description
      };
      //console.log(newPlayer);
      props.addPlayer(newPlayer);
    }
    else if (!modeRegisterDlg && selectedPlayers.length === 1)
    {
      //const id = selectedPlayers[0];
      const updatePlayer = {
        id: player.id,
        name: player.name,
        file: player.file,
        file_size: player.file_size,
        meter_type: player.meter_type,
        version_code: player.version_code,
        modified_user: player.modified_user,
        modified_at: player.modified_at,
        description: player.description,
        prev_file: player.prev_file,
      };
      //console.log(updatePlayer);
      props.updatePlayer(updatePlayer.id, updatePlayer);
    }
    else {
      
    }
    setOpenDialog(false);
  };

  const handleClickOpenDeleteAlert = () => {
    if (selectedPlayers.length !== 1){
      return ;
    }
    setOpenDeleteAlert(true);
  };

  const handleSetSelectedPlayers = (checks) => {
    setSelectedPlayers(checks);
  }

  const handleClickDeleteAlertOk = () => {

    if (selectedPlayers.length !== 1){
      return ;
    }

    const id = selectedPlayers[0];
    const deletePlayer = players.find(player => (player.id === id));

    props.deletePlayer(deletePlayer.id);

    setOpenDeleteAlert(false);
  }
  
  const handleClickCloseDeleteAlert = () => {
    setOpenDeleteAlert(false);
  };

  useEffect(() => {
    //console.log("componentDidMount");
    const jwt = localStorage.getItem('jwt');
    //console.log(''+jwt);

    if (jwt) {
      const decoded = jwtDecode(jwt);

      if (decoded.userid !== null) {
        setUserId(decoded.userid);
      }
      if (decoded.name !== null) {
        setUserName(decoded.name);
      }
      if (decoded.role !== null) {
        setUserRole(decoded.role);
      }
    }

    props.getPlayers();

    return () => {
      //console.log("componentDidUnmount");
    };
  }, []); // empty-array means don't watch for any updates


  useEffect(() => {

    //setDisableRegisterButton(players.length > 0);
    setDisableEditButton(selectedPlayers.length !== 1);
    setDisableDeleteButton(selectedPlayers.length < 1);

  }, [selectedPlayers]);

  if (loading) {
    return <WaveLoading />;
  }

  return (
    <div className={classes.root}>

      <PageTitle 
        pageTitle={'플레이어'}
      />

      <PlayerToolbar 
        userRole={userRole}
        onClickOpenRegisterDialog={handleClickOpenRegisterDialog}
        onClickOpenEditDialog={handleClickOpenEditDialog}
        onClickOpenDeleteDialog={handleClickOpenDeleteAlert}
        disableRegisterButton={disableRegisterButton}
        disableEditButton={disableEditButton}
        disableDeleteButton={disableDeleteButton}
        />

      <div className={classes.content}>
        <PlayerTable 
          players={players}
          onSetSelectedPlayers={handleSetSelectedPlayers}
          />
      </div>

      <RegAndEditPlayer
        openDialog={openDialog}
        onClickCloseDialog={handleClickCloseDialog}
        onClickSavePlayer={handleClickSavePlayer}
        editPlayer={editPlayer}
        modeRegisterDlg={modeRegisterDlg}
        userName={userName}
        />

      <SimplePopup
        title={`플레이어를 삭제하시겠습니까?`} 
        openPopup={openDeleteAlert} 
        onClickClose={handleClickCloseDeleteAlert} 
        onClickOk={handleClickDeleteAlertOk}
        />
        
    </div>
  );
};

Player.propTypes = {
  loading: PropTypes.bool,
  players: PropTypes.arrayOf(PropTypes.object),
};

Player.defaultProps = {
  loading: false,
  players: [],
};

const mapStateToProps = state => ({
  loading: state.players.loading,
  players: state.players.playerList,
});

const mapDispatchToProps = dispatch => ({
  getPlayers: () => {getPlayers(dispatch)},
  addPlayer: (category) => {addPlayer(category, dispatch)},
  updatePlayer: (id, category) => {updatePlayer(id, category, dispatch)},
  deletePlayer: (id) => {deletePlayer(id, dispatch)},
})
  
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Player);